import { render, staticRenderFns } from "./ConfiguracaoScoreView.vue?vue&type=template&id=6d7fc75c&scoped=true"
import script from "./ConfiguracaoScoreView.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoScoreView.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoScoreView.vue?vue&type=style&index=0&id=6d7fc75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7fc75c",
  null
  
)

export default component.exports